import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import MarketingNav from "@/components/MarketingNav";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-[#F9F8F6]" data-testid="refund-policy-page">
      <MarketingNav />
      <section className="max-w-[820px] mx-auto px-6 md:px-10 py-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#5E5E5E] hover:text-[#1C3F35] transition-colors"
          data-testid="refund-back-home"
        >
          <ArrowLeft className="w-4 h-4"/> Back to home
        </Link>

        <div className="mt-8">
          <div className="label-eyebrow mb-4">Legal</div>
          <h1 className="font-heading font-light text-5xl md:text-6xl tracking-tighter text-[#1A1A1A]">
            Refund &amp; Cancellation Policy
          </h1>
          <p className="text-[#7A8C77] mt-3 text-sm">Last updated: February 17, 2026</p>
        </div>

        <article className="mt-12 space-y-10 text-[#1A1A1A]">
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-md bg-[#1C3F35] flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5}/>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-medium tracking-tight">
                Refund Policy
              </h2>
            </div>
            <p className="text-[#3D3D3D] leading-relaxed">
              Due to the digital nature of our products and services, all sales are final.
              Once a purchase or subscription payment has been processed, no refunds, exchanges,
              or credits will be issued, whether in whole or in part.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-md bg-[#C1654B] flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5}/>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-medium tracking-tight">
                Subscription Cancellation
              </h2>
            </div>
            <div className="space-y-4 text-[#3D3D3D] leading-relaxed">
              <p>
                You may cancel your subscription at any time through your account settings.
                Your cancellation will stop future recurring charges.
              </p>
              <p>
                If you cancel after a payment has been processed, your subscription will remain
                active until the end of your current billing period. No prorated refunds or
                credits will be provided for any unused portion of the subscription period.
              </p>
              <p>
                After your current billing period ends, your subscription will automatically
                terminate, and you will not be charged again unless you choose to reactivate
                your subscription.
              </p>
            </div>
          </section>

          <section className="border-l-4 border-[#1C3F35] bg-[#1C3F35]/5 px-6 py-5 rounded-r-md">
            <p className="text-[#1C3F35] text-sm md:text-base leading-relaxed">
              By purchasing or subscribing, you acknowledge and agree to this
              No Refund and Cancellation Policy.
            </p>
          </section>
        </article>

        <div className="mt-16 pt-8 border-t border-[#E6E4DF] flex flex-wrap items-center justify-between gap-4 text-sm text-[#5E5E5E]">
          <div>Questions? Reach us at{" "}
            <a href="mailto:Contact@BeaconofGrants.org" className="text-[#1C3F35] underline underline-offset-4" data-testid="refund-contact-link">
              Contact@BeaconofGrants.org
            </a>
          </div>
          <Link to="/pricing" className="text-[#1C3F35] hover:underline underline-offset-4" data-testid="refund-to-pricing">
            View pricing →
          </Link>
        </div>
      </section>
    </div>
  );
}
